import React, { useState } from "react";
import "./SwitchView.css";
import { useDispatch } from "react-redux";
import { setCurrentView } from "../../redux/reducers/ViewTypeReducer";

const SwitchView = () => {
  const dispatch = useDispatch();

  const [isGridView, setIsGridView] = useState(true);

  const toggleView = () => {
    setIsGridView(!isGridView);
  };

  return (
    <div className="delicious100-interactive__switch_view">
      <span
        className={`delicious100-interactive__grid-button ${
          isGridView ? "active" : ""
        }`}
        onClick={() => {
          toggleView();
          dispatch(setCurrentView("GRID_VIEW"));
        }}
      >
        Grid View
      </span>
      <span
        className={`delicious100-interactive__map-button ${
          !isGridView ? "active" : ""
        }`}
        onClick={() => {
          toggleView();
          dispatch(setCurrentView("MAP_VIEW"));
        }}
      >
        Map View
      </span>
    </div>
  );
};

export default SwitchView;
